<div class="auth-sign-up__body">
    <div class="auth-sign-up__form">
        <div class="create-ai-assistant-form-view__form-div">
            <h1 class="auth-sign-up__title">{{ 'Your website is waiting for you.' }}</h1>
            <span class="auth-sign-up__desc mt6">{{ 'Create your account now to access your newly  generated site.' }}</span>
            <form [formGroup]="signUpForm" class="create-ai-assistant-form-view__form">
                <div class="auth-sign-up__form-inputs">
                    <div>
                        <div class="db-google-block mb20" *ngIf="companyInfo?.branding?.google_client_id">
                          <db-google-auth (verifyGoogleToken)="signUpWithGoogle($event)" [loading]="googleBtnLoading"
                [googleClientId]="companyInfo?.branding?.google_client_id"></db-google-auth>
                        </div>

                        <div class="db-email-block">
                            <a (click)="signUpWithEmail()" class="db-button_email ds-btn-outline-eggshell ds-btn-xl"><i
                                    *ngIf="!emailBtnLoading" class="db-icon db-icon-ds-email"></i>
                                <span *ngIf="!emailBtnLoading">{{ 'text_signUpWithEmail' | dbText }}</span>
                                <db-loading-circular-spinner color="dark"
                                                             *ngIf="!!emailBtnLoading"></db-loading-circular-spinner>
                            </a>
                        </div>

                    </div>
                </div>
            </form>

        </div>
    </div>

  <div class="auth-sign-up__have-account">
    <p>By signing up, you agree to 10Web’s <a href="https://10web.io/terms-of-service" target="_blank"
                                              rel="noopener" class="ds-link">Terms of Service</a><br
      *ngIf="!isMobile"/> and <a class="sign-up confirm-terms ds-link"
                                 href="https://10web.io/privacy-policy" target="_blank"
                                 rel="noopener">Privacy Policy</a>.</p>
  </div>
</div>
